import { render, staticRenderFns } from "./installDevices.vue?vue&type=template&id=56f4b36d&"
import script from "./installDevices.vue?vue&type=script&lang=js&"
export * from "./installDevices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports